import { useAuth0 } from '@auth0/auth0-react';
import { datadogRum } from '@datadog/browser-rum';
import { ENV_CONFIG } from 'config/environment';
import { mixpanelClient } from 'helpers/mixpanel';
import { clearAccessToken } from 'services/storage';

export const useLogout = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    clearAccessToken();
    mixpanelClient.reset();
    datadogRum.clearUser();
    logout({ logoutParams: { returnTo: ENV_CONFIG().SITE_URL } });
  };

  return { handleLogout };
};
